import { useState } from 'react';
import { Button, Input, Stack, Text } from '@chakra-ui/react';
import { coordinateService } from '../../lib/services/coordinateService';
import { useMap } from '../map/map-context';
import { fromLonLat } from 'ol/proj';

export default function CitySearch({ onClose }: { onClose: () => void }) {
  const [cityName, setCityName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { map } = useMap();

  const handleSearch = async () => {
    if (!cityName.trim()) {
      setError('Please enter a city name');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const coordinates = await coordinateService.geocodeCity(cityName.trim());

      if (map) {
        const view = map.getView();
        view.animate({
          center: fromLonLat([coordinates.longitude, coordinates.latitude]),
          zoom: 14,
          duration: 1000,
        });
        onClose();
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to find city');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Stack gap='4'>
      <div>
        <Text fontSize='sm' mb='1'>
          Place Name
        </Text>
        <Input
          placeholder='e.g. Saskatoon, Regina, Prince Albert'
          value={cityName}
          onChange={(e) => setCityName(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>

      {error && (
        <Text color='red.500' fontSize='sm'>
          {error}
        </Text>
      )}

      <Button onClick={handleSearch} loading={loading} disabled={!cityName.trim()}>
        Search
      </Button>
    </Stack>
  );
}
